import React from 'react';
import { useEffect, useRef, useState } from "react";
import { loadAdSenseScript, isAdSenseEnabled } from '../../utils/adsenseLoader';

// NOTE: We're periodically changing the ins element key value, which forces React to generate a new element entirely
// Google Adsense expects a fresh empty ins element every time a new ad is requested for it.

const BannerAd = ( { slot, format, customStyle, refreshSec = 60 } ) =>
{
  // Don't render anything if ads are disabled
  if( !isAdSenseEnabled() )
  {
    return null;
  }

  const [ adKey, setAdKey ] = useState( 0 );
  const [ scriptLoaded, setScriptLoaded ] = useState( false );
  const adRef = useRef();

  // Load AdSense script when component mounts (only if ads are enabled)
  useEffect( () =>
  {
    loadAdSenseScript()
      .then( () => setScriptLoaded( true ) )
      .catch( ( error ) =>
      {
        console.warn( "Failed to load AdSense script:", error );
      } );
  }, [] );

  useEffect( () =>
  {
    if( !scriptLoaded ) return;

    const interval = setInterval( () =>
    {
      if( adRef.current && adRef.current.offsetParent !== null )
      {
        setAdKey( prev => prev + 1 ); // force remount
      }
    }, refreshSec * 1000 );

    return () => clearInterval( interval );
  }, [ refreshSec, scriptLoaded ] );

  useEffect( () =>
  {
    if( adRef.current && scriptLoaded )
    {
      try
      {
        // console.log( 'adsbygoogle PUSH slot', slot, 'adKey', adKey, 'refreshSec', refreshSec );
        ( window.adsbygoogle = window.adsbygoogle || [] ).push( {} );
      }
      catch( e )
      {
        console.warn( "AdSense load failed:", e );
      }
    }
  }, [ adKey, scriptLoaded ] );

  return (
    <ins
      key={ adKey }
      ref={ adRef }
      className="adsbygoogle"
      style={
        customStyle ??
        {
          display: "block",
        } }
      data-ad-client="ca-pub-9609772701049084"
      data-ad-slot={ slot }
      data-ad-format={ format }
      data-full-width-responsive="true"
      data-adtest={ process.env.NODE_ENV === "development" ? "on" : undefined }
    ></ins>
  );
}


export default React.memo( BannerAd,
  ( prevProps, nextProps ) =>
  {
    // NOTE: We never want this component to be re-rendered because the parent component is re-rendering.
    return true;
  }
);
